import {
  Sparkles,
  Droplets,
  Shirt,
  Layers,
  Eraser,
  Gem,
  BedDouble,
  Scissors,
} from "lucide-react";

export const WHATSAPP_NUMBER = "447568487789";
export const PHONE_PRIMARY_DISPLAY = "+44 7568 487789";
export const PHONE_PRIMARY_TEL = "+447568487789";
export const PHONE_ALT_DISPLAY = "07497 367289";
export const PHONE_ALT_TEL = "+447497367289";
export const ADDRESS = "148 High St, Yiewsley, West Drayton UB7 7BD";
export const MAPS_EMBED_URL =
  "https://www.google.com/maps?q=148%20High%20St%2C%20Yiewsley%2C%20West%20Drayton%20UB7%207BD&output=embed";
export const MAPS_DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=148+High+St,+Yiewsley,+West+Drayton+UB7+7BD";

export const HOURS = [
  { days: "Monday — Saturday", time: "9:00 AM — 7:00 PM" },
  { days: "Sunday", time: "10:00 AM — 4:00 PM" },
];

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "About Us", id: "about" },
  { label: "Commercial / Hotels", id: "commercial" },
  { label: "How It Works", id: "how-it-works" },
  { label: "Contact", id: "contact" },
];

export const SERVICES = [
  {
    slug: "dry-cleaning",
    name: "Dry Cleaning",
    description:
      "Expert care for suits, coats and delicate fabrics — cleaned, finished and returned immaculate.",
    icon: Sparkles,
  },
  {
    slug: "wet-cleaning-laundry",
    name: "Wet Cleaning & Laundry",
    description:
      "Fresh, thorough cleaning for everyday wear — gentle on fibres and kind to skin.",
    icon: Droplets,
  },
  {
    slug: "shirt-laundering",
    name: "Shirt Laundering & Pressing",
    description:
      "Crisp collars, sharp cuffs and a professional finish, every single time.",
    icon: Shirt,
  },
  {
    slug: "wash-and-fold",
    name: "Wash & Fold",
    description:
      "A convenient per-kg service — washed, dried and neatly folded, ready for the drawer.",
    icon: Layers,
  },
  {
    slug: "stain-removal",
    name: "Stain Removal",
    description:
      "Advanced treatment for stubborn spots and marks, handled by experienced hands.",
    icon: Eraser,
  },
  {
    slug: "leather-suede",
    name: "Leather & Suede Treatment",
    description:
      "Specialist cleaning and conditioning for leather and suede jackets and coats.",
    icon: Gem,
  },
  {
    slug: "household-cleaning",
    name: "Household Item Cleaning",
    description:
      "Duvets, blankets, sheets and curtains — refreshed, sanitised and beautifully finished.",
    icon: BedDouble,
  },
  {
    slug: "alterations-gowns",
    name: "Alterations & Gown Preservation",
    description:
      "Precise garment alterations, plus specialist preservation for wedding gowns.",
    icon: Scissors,
  },
];

export const BOOKABLE_SERVICES = [
  ...SERVICES.map((s) => s.name),
  "Commercial / Hotel Services",
  "Other / Not sure",
];

export const GOOGLE_REVIEW_URL =
  "https://www.google.com/maps/search/?api=1&query=R%26J%20Dry%20Cleaners%2C%20148%20High%20St%2C%20Yiewsley%2C%20West%20Drayton%20UB7%207BD";

export const REVIEWS = [
  {
    name: "James W.",
    area: "West Drayton",
    text: "My suits came back looking brand new — crisp pressing, not a crease out of place. The attention to detail is on another level.",
  },
  {
    name: "Priya S.",
    area: "Yiewsley",
    text: "Booked on WhatsApp in under a minute, collected from my door the same afternoon, and returned fresh two days later. Effortless.",
  },
  {
    name: "Eleanor M.",
    area: "Hillingdon",
    text: "They rescued a silk dress I thought was ruined. Honest advice, gentle care, and such friendly people. I won't go anywhere else.",
  },
  {
    name: "Daniel R.",
    area: "Local Business Owner",
    text: "Reliable, punctual and impeccably finished every single week. Our guest house linens have never looked better.",
  },
];

export function openWhatsApp(message) {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

export const GENERAL_WHATSAPP_MESSAGE =
  "Hello R&J Dry Cleaners! I'd like to enquire about your services.";

export const COMMERCIAL_WHATSAPP_MESSAGE = [
  "Hello R&J Dry Cleaners!",
  "",
  "I'm enquiring about your commercial & hotel laundry services.",
  "",
  "Business Name:",
  "Type of Business (Hotel / Restaurant / Office / Other):",
  "Items & Estimated Volume:",
  "Preferred Pickup Schedule:",
  "",
  "Please get in touch to discuss a tailored partnership. Thank you!",
].join("\n");

export function buildBookingMessage({ name, phone, address, mapLink, services, date, time }) {
  const lines = [
    "Hello R&J Dry Cleaners!",
    "",
    "* New Pickup Booking *",
    "----------------------------",
    `Name: ${name}`,
    `Phone: ${phone}`,
    `Pickup Address: ${address}`,
  ];
  if (mapLink && mapLink.trim()) {
    lines.push(`Google Maps Location: ${mapLink.trim()}`);
  }
  lines.push(
    `Services: ${services.join(", ")}`,
    `Preferred Date: ${date}`,
    `Preferred Time: ${time}`,
    "----------------------------",
    "",
    "Please confirm my pickup. Thank you!"
  );
  return lines.join("\n");
}

export function buildCommercialMessage({ business, contact, phone, address, requirement }) {
  return [
    "Hello R&J Dry Cleaners!",
    "",
    "* Commercial / Hotel Enquiry *",
    "----------------------------",
    `Business / Hotel: ${business}`,
    `Contact Person: ${contact}`,
    `Phone: ${phone}`,
    `Business Address: ${address}`,
    `Requirement: ${requirement}`,
    "----------------------------",
    "",
    "Please get in touch to discuss a tailored partnership. Thank you!",
  ].join("\n");
}

const DAY_HOURS = [
  { open: 600, close: 960 },
  { open: 540, close: 1140 },
  { open: 540, close: 1140 },
  { open: 540, close: 1140 },
  { open: 540, close: 1140 },
  { open: 540, close: 1140 },
  { open: 540, close: 1140 },
];

function formatMinutes(mins) {
  const h24 = Math.floor(mins / 60);
  const suffix = h24 >= 12 ? "PM" : "AM";
  const h = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h}:00 ${suffix}`;
}

export function getOpenStatus() {
  const london = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Europe/London" })
  );
  const day = london.getDay();
  const nowMins = london.getHours() * 60 + london.getMinutes();
  const today = DAY_HOURS[day];
  if (nowMins >= today.open && nowMins < today.close) {
    return { open: true, label: `Open Now · Closes ${formatMinutes(today.close)}` };
  }
  if (nowMins < today.open) {
    return { open: false, label: `Opens ${formatMinutes(today.open)} Today` };
  }
  const next = DAY_HOURS[(day + 1) % 7];
  return { open: false, label: `Opens ${formatMinutes(next.open)} Tomorrow` };
}
